<template>
	<div class="property-index-container">
		<div class="vc-index-nav">
			<span>
				<i class="el-icon-s-home margin-right-sm"></i>
				{{ $t('propertyIndex.home') }}
			</span>
			<span class="margin-left-sm margin-right-sm">/</span>
			<span>{{ $t('propertyIndex.dashboard') }}</span>
		</div>

		<!-- 第一行: 资产总览、经营数据总览、快捷入口 -->
		<el-row class="vc-index-row" :gutter="12">
			<el-col :span="12">
				<div class="module-wrapper">
					<AssetOverview :assetOverview="assetOverview" />
				</div>
			</el-col>
			<el-col :span="12">
				<div class="module-wrapper">
					<BusinessDataOverview :businessOverview="businessOverview" />
				</div>
			</el-col>
		</el-row>
		<!-- 
		<el-row class="vc-index-row" :gutter="12">
			<el-col :span="16">
				<div class="module-wrapper">
					<QuickEntry />
				</div>
				<div class="module-wrapper">
					<WorkOrderInfo />
				</div>
				<el-row class="vc-index-row" :gutter="12">
					<el-col :span="12" style="height: 100% !important">
						<div class="module-wrapper">
							<AssetCategoryStatistics />
						</div>
					</el-col>
					<el-col :span="12">
						<div class="module-wrapper">
							<AssetPlanningType />
						</div>
					</el-col>
				</el-row>
			</el-col>
			<el-col :span="8" style="height: 100% !important; display: flex; flex-direction: column; background-color: red">
				<div class="module-wrapper">
					<WarningReminder />
				</div>
				<div class="module-wrapper">
					<LeaseStatusStatistics :assetRentStats="assetRentStats" />
				</div>
				<div class="module-wrapper">
					<AssetTrends />
				</div>
			</el-col>
		</el-row> -->
		<el-row class="vc-index-row dashboard" :gutter="12">
			<!-- 左侧 -->
			<el-col :span="16" class="left-col">
				<div class="module-wrapper auto">
					<QuickEntry />
				</div>

				<div class="module-wrapper auto">
					<WorkOrderInfo />
				</div>

				<div class="bottom-row">
					<div class="module-wrapper">
						<AssetCategoryStatistics />
					</div>
					<div class="module-wrapper">
						<AssetPlanningType />
					</div>
				</div>
			</el-col>

			<!-- 右侧 -->
			<el-col :span="8" class="right-col">
				<div class="module-wrapper r1">
					<WarningReminder />
				</div>
				<div class="module-wrapper r2">
					<LeaseStatusStatistics :assetRentStats="assetRentStats" />
				</div>
				<div class="module-wrapper r3">
					<AssetTrends />
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import AssetOverview from './assetOverview.vue';
	import BusinessDataOverview from './businessDataOverview.vue';
	import QuickEntry from './quickEntry.vue';
	import AssetCategoryStatistics from './assetCategoryStatistics.vue';
	import AssetPlanningType from './assetPlanningType.vue';
	import WarningReminder from './warningReminder.vue';
	import LeaseStatusStatistics from './leaseStatusStatistics.vue';
	import AssetTrends from './assetTrends.vue';
	import WorkOrderInfo from './workOrderInfo.vue';
	import { getHomeStats } from '@/api/home/homeApi.js';
	export default {
		name: 'IndexPropertyNew',
		components: {
			AssetOverview,
			BusinessDataOverview,
			QuickEntry,
			AssetCategoryStatistics,
			AssetPlanningType,
			WarningReminder,
			LeaseStatusStatistics,
			AssetTrends,
			WorkOrderInfo,
		},
		data() {
			return {
				assetOverview: null,
				businessOverview: null,
				assetRentStats: null,
			};
		},
		async mounted() {
			const { data } = await getHomeStats();
			this.assetOverview = data.assetOverview || {};
			this.businessOverview = data.businessOverview || {};
			this.assetRentStats = data.assetRentStats || {};
		},
		methods: {},
	};
</script>

<style lang="scss" scoped>
	.property-index-container {
		text-align: left;
		padding: 0 10px;
		:deep(.el-card) {
			border-radius: 16px;
			height: 100%;
			.el-card__header {
				border-bottom: none;
				padding-bottom: 0;
			}
			.el-card__body {
				box-sizing: border-box !important;
			}
		}

		.vc-index-nav {
			padding: 10px;
			font-size: 16px;
			text-align: left;
		}

		.vc-index-row {
			text-align: left;
			margin-bottom: 10px;
		}
		.dashboard {
			display: flex;
		}

		.left-col,
		.right-col {
			display: flex;
			flex-direction: column;
		}

		/* 左侧模块 */
		.left-col .module-wrapper.auto {
			margin-bottom: 12px;
		}

		/* 左侧底部两块平分 */
		.bottom-row {
			display: flex;
			flex: 1;
			gap: 12px;
		}

		.bottom-row .module-wrapper {
			flex: 1;
		}

		/* 右侧按比例分配高度 */
		.right-col .r1 {
			height: 232px;
			margin-bottom: 10px;
		}
		.right-col .r2 {
			height: 321px;
			margin-bottom: 10px;
		}
		.right-col .r3 {
			flex: 1; /* 40% */
		}

		/* 通用模块 */
		.module-wrapper {
			border-radius: 6px;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			overflow: hidden;
		}
	}
</style>
